export default __webpack_public_path__ + "static/media/Banner.39df4e68.webp";